import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RaisedButton from 'material-ui/RaisedButton';
import Subheader from 'material-ui/Subheader';

import * as accounts_actions from 'data/accounts/actions';
import * as users_actions from 'data/users/actions';

import { Page, PageSection, PageBlock, RightDrawer} from 'components/Page';

import Row from 'components/Form/Row';
import Field from 'components/Form/Field';

class Account extends Component {
  state = { };

  static contextTypes = {
    router: PropTypes.object
  };

  handleCancel(id) {
    this.context.router.history.push("/admin/accounts");
  }


  componentWillMount() {
    this.props.actions.fetchAccount(this.props.params.id);
    this.props.actions.fetchUsers();
  }

  handleFormSubmit(event) {
    

    this.props.actions.updateAccount(this.props.params.id, {
      street: this.street.state.value,
      zip: this.zip.state.value,
      city: this.city.state.value,
      orgname: this.orgname.state.value,
      orgphone: this.orgphone.state.value,
      orgemail: this.orgemail.state.value,
      orgnum: this.orgnum.state.value, 
    });

  }

  render() {
    var {orgname, orgphone, orgemail, orgnum, street, zip, city} = this.props.account;

    return [
      <RightDrawer key="right">
        <PageBlock label="Konto">
        
        </PageBlock>
      </RightDrawer>,
      <Page key="page"  ready={!this.props.pending}>
       
          <PageSection label="Företag">
            <Row>
              <Field floatingLabelText="Organisationsnummer" ref={(f) => this.orgnum = f} value={orgnum} />
            </Row>
            <Row>
              <Field floatingLabelText="Företagsnamn" ref={(f) => this.orgname = f} value={orgname} />
            </Row>
            <Row>
              <Field floatingLabelText="E-postadress" ref={(f) => this.orgemail = f} value={orgemail} />
            </Row>
            <Row>
              <Field floatingLabelText="Telefon" ref={(f) => this.orgphone = f} value={orgphone} />
            </Row>
            <Row>
              <Field floatingLabelText="Gatuadress" ref={(f) => this.street = f} value={street} />
            </Row>
            <Row>
              <Field floatingLabelText="Postnummer" ref={(f) => this.zip = f} value={zip} />
            </Row>
            <Row>
              <Field floatingLabelText="Postort" ref={(f) => this.city = f} value={city} />
            </Row>
          </PageSection>
          <PageSection label="Företag">
            <Row styleName="padded">
              <RaisedButton onTouchTap={this.handleFormSubmit.bind(this)} type="submit" primary={true}  label="Spara" />
              <RaisedButton onTouchTap={this.handleCancel.bind(this)} label="Stäng" />
            </Row>
          </PageSection>
      </Page>
    ]
  }
}


function mapStateToProps(state, ownProps) {


  return { 
    account: state.account ,
    pending: !state.account
  };
}
const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...accounts_actions , ...users_actions }, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatch)(Account)

  



// WEBPACK FOOTER //
// ./src/pages/admin/accounts/Account.jsx